import { styled } from '@linaria/react';

import { P } from '~components/Typography';

export const RatingContainer = styled.div`
	display: flex;
	justify-content: space-around;
	align-items: center;
	gap: 8px;
	padding-top: 48px;
	width: 100%;
`;

export const RatingItemTitle = styled(P)`
	position: absolute;
	bottom: 100%;
	left: -20px;
	right: -20px;
	margin-bottom: 10px;
	white-space: nowrap;
	opacity: 0;
	transform: translateY(-20px);
	transition: opacity 0.2s, transform 0.2s, color 0.2s;
	pointer-events: none;

	@media screen and (max-width: 600px) {
		left: -10px;
		font-size: 12px;
		text-align: center;
	}
`;

export const RatingItem = styled.label`
	position: relative;
	width: 56px;
	aspect-ratio: 1 / 1;
	cursor: pointer;

	@media screen and (max-width: 600px) {
		width: 48px;
	}

	@media (pointer: fine) {
		&:hover {
			${RatingItemTitle} {
				opacity: 1;
				transform: translateY(0);
			}
		}
	}
`;

export const RatingItemInput = styled.input`
	position: absolute;
	left: 0;
	opacity: 0;

	& ~ img {
		transition: filter 0.2s, transform 0.2s;
	}

	&:checked {
		& ~ ${RatingItemTitle} {
			color: var(--color-white);
			opacity: 1;
			transform: translateY(0);
		}
	}

	&:not(:checked) {
		& ~ img {
			filter: grayscale(1);
			transform: scale(0.8);
		}
	}
`;
